import GET_COUNTRIES from "./getCountries"
import GET_COUNTRIES_WAVE from "./getCountriesWave"
import GET_COUNTRY_BY_ID from "./getCountryById"
import GET_LABEL_BY_ID from "./getLabelById"
import GET_LABELS from "./getLabels"
import GET_LABELS_WAVE from "./getLabelsWave"
import GET_STORE_BY_ID from "./getStoreById"
import GET_STORE_LINK_BY_ID from "./getStoreLinkById"
import GET_STORE_LINKS from "./getStoreLinks"
import GET_STORES from "./getStores"
import GET_STORES_WAVE from "./getStoresWave"
import GET_VENDOR_BY_ID from "./getVendorById"
import GET_VENDORS from "./getVendors"
import GET_VENDORS_WAVE from "./getVendorsWave"
import SEARCH_LABELS from "./searchLabels"
import SEARCH_LABELS_BY_URL from "./searchLabelsByUrl"
import SEARCH_STORES from "./searchStores"
import SEARCH_VENDORS from "./searchVendors"

export default {
  GET_COUNTRIES,
  GET_COUNTRIES_WAVE,
  GET_COUNTRY_BY_ID,
  GET_LABELS,
  GET_LABELS_WAVE,
  GET_LABEL_BY_ID,
  GET_STORES,
  GET_STORES_WAVE,
  GET_STORE_BY_ID,
  GET_STORE_LINKS,
  GET_STORE_LINK_BY_ID,
  GET_VENDORS,
  GET_VENDORS_WAVE,
  GET_VENDOR_BY_ID,
  SEARCH_LABELS,
  SEARCH_LABELS_BY_URL,
  SEARCH_STORES,
  SEARCH_VENDORS
}
